import { IStudentTask } from "../models/student";
import { HttpUtils } from "./http-utils";

export class CompletedTicketService {

    httpUtils: HttpUtils;
    webApiUrl: string;

    constructor() {
        this.httpUtils = new HttpUtils();
        this.webApiUrl = `/darshana/api/completed-tickets`;
    }

    saveTasks = async (tasks: IStudentTask[], successHandler: (() => any)) => {

        const mappedTasks = tasks.map(t => { return { id: t.id, status: t.status, studentAnswer: t.studentAnswer, studentPoint: t.studentPoints } });

        const options = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tasks: mappedTasks })
        }

        fetch(`${this.webApiUrl}/tasks`, options)
            .then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    finished = async (id: number, successHandler: ((data: any) => any)) => {

        const options = {
            method: "PUT"
        }

        fetch(`${this.webApiUrl}/${id}/finished`, options).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };
}